// Attention!
// Do not edit directly! The hardcoded values of these tokens are token references
// that get resolved when the .js/d.ts files are being generated from the token JSON files.
export const SEM_BORDER_RADIUS_ACTION_DEFAULT = '0px';
export const SEM_BORDER_RADIUS_ACTION_MAX = '999px';
export const SEM_BORDER_RADIUS_FORMS_DEFAULT = '0px';
export const SEM_BORDER_RADIUS_FORMS_MAX = '999px';
export const SEM_BORDER_RADIUS_UI_RADIUS_MAX = '999px';
export const SEM_BORDER_RADIUS_UI_DEFAULT = '0px';
export const CMP_BORDER_RADIUS_UI_DRAWER_DEFAULT = '8px';
export const SYS_BORDER_RADIUS_NONE = '0px';
export const SYS_BORDER_RADIUS_XS = '2px';
export const SYS_BORDER_RADIUS_SM = '4px';
export const SYS_BORDER_RADIUS_MD = '8px';
export const SYS_BORDER_RADIUS_MAX = '999px';
//# sourceMappingURL=border-radius.generated.js.map